/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductReference } from './ProductReference';
import {
    ProductReferenceFromJSON,
    ProductReferenceFromJSONTyped,
    ProductReferenceToJSON,
} from './ProductReference';

/**
 * Representation of a Product Reference List
 * @export
 * @interface ProductReferenceList
 */
export interface ProductReferenceList {
    /**
     * List of product references
     * @type {Array<ProductReference>}
     * @memberof ProductReferenceList
     */
    references?: Array<ProductReference>;
}

/**
 * Check if a given object implements the ProductReferenceList interface.
 */
export function instanceOfProductReferenceList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductReferenceListFromJSON(json: any): ProductReferenceList {
    return ProductReferenceListFromJSONTyped(json, false);
}

export function ProductReferenceListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductReferenceList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'references': !exists(json, 'references') ? undefined : ((json['references'] as Array<any>).map(ProductReferenceFromJSON)),
    };
}

export function ProductReferenceListToJSON(value?: ProductReferenceList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'references': value.references === undefined ? undefined : ((value.references as Array<any>).map(ProductReferenceToJSON)),
    };
}

